<template>
  <div class="clients">
    <v-row>
      <v-col cols="12" sm="6">
        <div class="areaTitle">
          <h2>Clients</h2>
          <v-btn
            color="primary"
            depressed
            :disabled="!showFormButtons"
            @click.stop="onAddNewClient"
            class="mr-2"
          >
            <v-icon class="mr-2">mdi-plus</v-icon>
            Add new clients
          </v-btn>
        </div>
        <v-card class="pa-2 adressesList" outlined tile>
          <v-data-table
            v-model="selectedClient"
            :headers="headers"
            :items="clientList"
            :items-per-page="-1"
            item-key="Id"
            single-select
            dense
            @click:row="selectClient"
          >
          </v-data-table>
        </v-card>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col cols="12" sm="6">
        <v-alert v-if="!isEditMode && !isSelectedClientExists" outlined dense type="info">
          Please select client or add the new.
        </v-alert>
        <div v-else class="formContainer">
          <v-form ref="clientForm" v-model="isFormValid" lazy-validation class="clientForm">
            <FormPanel :formElements="tabElements" :readOnly="!isEditMode"></FormPanel>
          </v-form>
          <div v-if="showFormButtons" class="formFooter">
            <div class="btnContainer">
              <v-btn
                v-if="!isEditMode && isSelectedClientExists"
                outlined
                color="error"
                @click="onDelete"
                >Delete</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn v-if="!isEditMode" outlined color="primary" @click="onEdit">Edit</v-btn>
              <v-btn v-if="isEditMode" outlined color="primary" @click="onCancel">Cancel</v-btn>
              <v-btn
                v-if="isEditMode"
                depressed
                color="primary"
                @click="saveChanges"
                class="ml-4"
                :disabled="!isFormValid"
                >Save</v-btn
              >
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <Dialog ref="messageBox" v-model="dialog"></Dialog>
  </div>
</template>
<script>
import Dialog from '@/components/layout/Dialog.vue';
import FormPanel from '@/components/FormPanel.vue';
import Utils from '@/utils.js';

export default {
  name: 'Clients',
  components: {
    FormPanel,
    Dialog,
  },
  data() {
    return {
      tabElements: [],
      formElements: [],
      isEditMode: false,
      dialog: false,
      clientList: [],
      currentClient: null,
      headers: [{ text: 'Name', value: 'ShortName' }],
      selectedClient: [],
      isFormValid: false,
    };
  },

  mounted: function () {
    this.getClientForm();
    this.getClientList();
  },

  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
    isSelectedClientExists() {
      return this.selectedClient && this.selectedClient.length > 0;
    },
  },

  watch: {},

  methods: {
    selectClient(item, row) {
      row.select(true);
      this.getClient(item.Id);
    },
    onAddNewClient() {
      this.clearData();
      this.selectedClient = [];
      this.isEditMode = true;
    },
    onEdit() {
      this.isEditMode = true;
    },
    onCancel() {
      this.isEditMode = false;
      if (this.isSelectedClientExists) this.getClient(this.selectedClient[0].Id);
      else this.clearData();
    },
    onDelete() {
      this.deleteClient();
    },
    saveChanges() {
      const isFormValid = this.$refs.clientForm.validate();
      if (isFormValid) {
        if (this.isSelectedClientExists) {
          this.updateClient();
        } else {
          this.addNewClient();
        }
      }
    },

    async getClient(clientId) {
      try {
        let response = await this.$api.get('/client/getclient', { params: { id: clientId } });

        if (!response.data) {
          const msg = 'Unable to load client with id ' + clientId;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }
        this.currentClient = response.data;
        var data = response.data;
        // match data with form fields
        if (data) Utils.setDataToFormElements(data, this.formElements);
      } catch (err) {
        console.error(err);
      }
    },
    async getClientList(clientId) {
      try {
        let response = await this.$api.get('/client/getClientList');
        var data = response.data;
        this.clientList = data;
        if (this.clientList && this.clientList.length > 0) {
          if (clientId) {
            const selected = this.clientList.find((x) => x.Id == clientId);
            if (selected) this.selectedClient = [selected];
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    async addNewClient() {
      try {
        const newClient = {};
        this.formElements.forEach((el) => {
          newClient[el.FieldName] = el.Value;
        });
        newClient.ClientId = 0;
        const response = await this.$api.post('/client/updateClient', newClient);
        const data = response.data;
        this.getClientList(data.Value);
        this.isEditMode = false;
      } catch (err) {
        console.error(err);
      }
    },
    async updateClient() {
      try {
        Object.keys(this.currentClient).forEach((e) => {
          var key = e;
          let item = this.formElements.find((o) => o.FieldName === key);
          if (item != null) {
            this.currentClient[e] = item.Value;
          }
        });
        await this.$api.post('/client/updateClient', this.currentClient);
        this.getClientList();
        this.isEditMode = false;
      } catch (err) {
        console.error(err);
      }
    },
    async deleteClient() {
      await this.$refs.messageBox.open(
        'Confirmation',
        'Are you sure you wish to delete this record ?'
      );

      try {
        await this.$api.delete('/client/deleteClient?id=' + this.currentClient.ClientId);
        this.selectedClient = [];
        this.clearData();
        this.getClientList();
      } catch (err) {
        console.error(err);
      }
    },
    clearData() {
      this.formElements.forEach(function (e) {
        e.Value = '';
      });
    },
    async getClientForm() {
      try {
        let response = await this.$api.get(
          '/datadictionary/GetFormElements?formName=Client&planId=' + this.currentPlanId
        );

        if (response.data.length) {
          var elements = response.data.filter((f) => f.Visible == true);
          this.formElements = elements;
          this.tabElements = elements.filter(
            (f) => f.ParentId === 'FormFields' && f.ChildPanel === ''
          );
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style scoped>
.clients {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 20px;
}

.clients .areaTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.clients .formContainer .clientForm {
  max-height: 700px;
  overflow-y: auto;
  padding-right: 10px;
}
</style>

<style lang="scss" scoped>
.formContainer {
  position: relative;
  height: 100%;

  .formFooter {
    bottom: 0;
    width: 100%;
    margin-top: 5px;

    position: sticky;
    background-color: white;
    padding: 8px 0 0 0;
    border-top: 1px solid rgba(0, 0, 0, 0.12);

    .btnContainer {
      display: flex;
    }
  }
}
</style>
